export default [
  {
      path: '/mng/org/importStaff',
      name: 'importStaff',
      component: () => import('@/pages/mng/staff_priv/importWorkWeixin/App.vue'),
      children: [
        {
          path: '/',
          name: 'importStaff',
          component: () => import('@/pages/mng/staff_priv/importWorkWeixin/pages/main.vue'),
          meta: {
            keepAlive: true,
            title: '从企业微信导入员工',
          },
        },
        {
          path: 'status/results',
          name: 'statusResults',
          component: () => import('@/pages/mng/staff_priv/importWorkWeixin/pages/status-results.vue'),
          meta: {
            keepAlive: true,
            title: '从企业微信导入员工',
          },
        },
        {
          path: 'ready',
          name: 'ready',
          component: () => import('@/pages/mng/staff_priv/importWorkWeixin/pages/ready.vue'),
          meta: {
            keepAlive: true,
            title: '从企业微信导入员工',
          },
        },
        {
          path: 'result',
          name: 'result',
          component: () => import('@/pages/mng/staff_priv/importWorkWeixin/pages/result.vue'),
          meta: {
            keepAlive: true,
            title: '从企业微信导入员工',
          },
        },
        {
          path: 'ruleImport',
          name: 'ruleImport',
          component: () => import('@/pages/mng/staff_priv/importWorkWeixin/components/import-with-rule/src/import-with-rule.vue'),
          meta: {
            keepAlive: true,
            title: '从企业微信导入员工',
          },
        },
      ],
    },
    {
      path: '/mng/org/importMembersList',
      name: 'importMembersList',
      component: () => import('@/pages/mng/staff_priv/importMembers/list/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/org/importMembersExport',
      name: 'importMembersExport',
      component: () => import('@/pages/mng/staff_priv/importMembers/export/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/org/importMembersChange',
      name: 'importMembersChange',
      component: () => import('@/pages/mng/staff_priv/importMembers/change/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/org/importMembersProcess',
      name: 'importMembersProcess',
      component: () => import('@/pages/mng/staff_priv/importMembers/process/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/org/importMembersChangeProcess',
      name: 'importMembersChangeProcess',
      component: () => import('@/pages/mng/staff_priv/importMembers/changeProcess/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/org/importMembersResult',
      name: 'importMembersResult',
      component: () => import('@/pages/mng/staff_priv/importMembers/result/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/org/importMembersChangeResult',
      name: 'importMembersChangeResult',
      component: () => import('@/pages/mng/staff_priv/importMembers/changeResult/App.vue'),
      meta: {
        title: '组织架构',
      },
    },
    {
      path: '/mng/role',
      component: () => import('@/pages/mng/staff_priv/privRole/App.vue'),
      children: [
        {
          path: '',
          name: 'list',
          component: () => import('@/pages/mng/staff_priv/privRole/pages/list.vue'),
          meta: {
            title: '权限角色',
            keepAlive: true,
          },
        },
        {
          path: 'edit/:roleId',
          name: 'edit',
          component: () => import('@/pages/mng/staff_priv/privRole/pages/edit.vue'),
          meta: {
            title: '权限角色',
          },
        },
        {
          path: 'create/:tplId/:name',
          name: 'create',
          component: () => import('@/pages/mng/staff_priv/privRole/pages/edit.vue'),
          meta: {
            title: '权限角色',
          },
        },
        {
          path: 'jumpcreate',
          name: 'jumpcreate',
          component: () => import('@/pages/mng/staff_priv/privRole/pages/list.vue'),
          meta: {
            title: '权限角色',
            showCreate: true,
          },
        },
      ],
    },
];
